/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';
import { Hideable } from '@regular_ui/lib/components/hideable';
import { nudgeUpHideableVariant } from '@prisjakt/customization_prisjakt/variants/hideable';

export const NudgedBox = styled(Hideable).attrs({
  // NOTE: Casting as `any` to suppress the TS error. Should be fixed when we have time
  variant: nudgeUpHideableVariant as any,
})`
  height: 80vh;
  position: fixed;
  width: 100%;
  /* Should be above sidebar */
  z-index: 100;
`;

export const Navigation = styled.nav`
  max-width: 1250px;
  margin-left: auto;
  margin-right: auto;

  ul {
    margin: 0;
    list-style-type: none;
  }
`;

export const NavigationWrapper = styled.div`
  flex: 0 0 100%;
  position: fixed;
  background: ${({ theme }) => theme.bg.primary};
  width: 100%;
  max-height: 80vh;
  overflow: hidden;
  z-index: 10;

  ${media.mediumDown`
    display: none;
  `};
`;

export const Overlay = styled.div`
  flex: 0 0 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${p => p.theme.bg.overlay};
  opacity: 0.9;

  transition: opacity 0.1s ease;
  visibility: visible;
  position: fixed;
  z-index: 9;
`;
